import React, { useState } from 'react';
import styles from './FAQSection.module.scss';
import SectionBadge from '../components/SectionBadge';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Is there a limit to how much content I can create?',
      answer: 'No! With the lifetime deal, you get unlimited AI-powered content campaigns. There are no caps on the number of content pieces you can create.',
    },
    {
      question: "What's included in the lifetime deal?",
      answer: 'The lifetime deal includes unlimited access to all Vocable features: AI-powered content campaigns, unlimited brand voices, multi-model text editor, content scoring, AI templates, channel integrations, and VIP community access.',
    },
    {
      question: 'Do I really get lifetime access with a one-time payment?',
      answer: "Yes! This is a one-time payment for lifetime access with no subscriptions. You'll receive access to all updates, and the current offering along with its updates and improvements will always be at no additional cost. We reserve the right to introduce credits in the future as we expand into more AI features.",
    },
    {
      question: 'Do I keep all future updates included in my plan?',
      answer: 'Absolutely. All lifetime deal customers receive every future update, new feature, and improvement at no additional cost.',
    },
    {
      question: 'Do you offer refunds on the lifetime deal?',
      answer: "No, because this is lifetime access and not a subscription, once you have unlocked access to the platform we can't issue a refund. Also this is a lifetime access and the platform is always improving with our users' direct feedback. Our users shape the features and improvements. So you're getting access to a system that's constantly evolving with your needs.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles.faq}>
      <div className={styles.container}>
        <div className={styles.badgeWrapper}>
          <SectionBadge>FAQ</SectionBadge>
        </div>

        <div className={styles.columnsWrapper}>
          <div className={styles.leftColumn}>
            <h2 className={styles.headline}>
              You've got questions.<br />
              We've got answers
            </h2>
            <p className={styles.contactText}>
              Have more questions? Shoot us an email at{' '}
              <a href="mailto:support@vocable.ai" className={styles.emailLink}>
                support@vocable.ai
              </a>
            </p>
          </div>

          <div className={styles.rightColumn}>
            <div className={styles.faqList}>
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`${styles.faqItem} ${openIndex === index ? styles.open : ''}`}
                >
                  <button
                    className={styles.faqQuestion}
                    onClick={() => toggleFAQ(index)}
                  >
                    <span>{faq.question}</span>
                    <svg
                      className={styles.chevron}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="currentColor"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className={styles.faqAnswer}>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
